import { EasingFunction, linear } from "./easing";
import { Quaternion, Vector3 } from "three";
import { rouler, RoulerPromise } from "./rouler";
import Signal from "../control-flow/signal";

type Posed = {
    position: Vector3,
    quaternion: Quaternion,
}

/**
 * I *think* this global is fine, provided we're only using it to trigger frame
 * re-renders.
 */
export const onChange = new Signal('onChange', 'view3d');

export const animatePose =
    (duration: number, animated: Posed, target: Posed, ease: EasingFunction = linear)
        : RoulerPromise =>
{
    const
        startPosition = animated.position.clone(),
        endPosition = target.position.clone(),
        startQuat = animated.quaternion.clone(),
        endQuat = target.quaternion.clone();

    return rouler(duration, (t: number) => {
        const e = ease(t);
        animated.position.lerpVectors(startPosition, endPosition, e);
        animated.quaternion.slerpQuaternions(startQuat, endQuat, e);
        onChange.trigger();
    });
}
